import {
  IRowPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";

export function getRowContainers(
  row: IRowPattern,
): (smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock) => TGetContainersFilterOutput {
  return function getRowContainersFn(
    smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
  ): TGetContainersFilterOutput {
    const { gridContent, allTiersKeys } = smartBay.getGridContent();
    const containers: TIContainerInformationExtendedValid[] = [];

    for (const tierKey of allTiersKeys) {
      const currContent = gridContent[row]?.[tierKey];
      if (!currContent) continue;
      containers.push(...(currContent.containers as TIContainerInformationExtendedValid[]));
    }

    return {
      containers,
      tBaysStr: smartBay.tBaysStr,
      level: smartBay.level,
    };
  };
}
